import { ITimeMachineParams } from './modules/stepper/TimeMachineStepper';

export const isAllStepCompleted = (timeMachineParams: ITimeMachineParams) => {
  return Object.values(timeMachineParams).every((value) => !!value);
};
